<app-shared-dialog
  [title]="(isUpdate ? 'knowledge_base.ignore_codes.dialog.title_edit' : 'knowledge_base.ignore_codes.dialog.title_create') | translate"
  [options]="{
    cancelText: 'common.cancel' | translate,
    customConfirmButton: true
  }"
  (cancel)="close()"
>
  <form class="information-form" [formGroup]="form">
    <div class="form-content">
      <!-- Description -->
      <p class="ignore-code-modal__description">
        {{ "knowledge_base.ignore_codes.dialog.description" | translate }}
      </p>

      <!-- Code -->
      <div class="standard-input">
        <label>{{ "knowledge_base.ignore_codes.dialog.code" | translate }}</label>
        <ui-form-field
          type="text"
          formControlName="code"
          [disabled]="!(canSubmit$ | async) || !!(submitting$ | async)"
          [placeholder]="'knowledge_base.ignore_codes.dialog.code_placeholder' | translate"
          [errorMessages]="{ required: ('validation.required' | translate) }"
        >
        </ui-form-field>
      </div>

      <!-- Customer (optional - empty for global) -->
      <div class="standard-input">
        <label>
          {{ "knowledge_base.ignore_codes.dialog.customer" | translate }}
          <span class="ignore-code-modal__optional">{{ "knowledge_base.ignore_codes.dialog.customer_optional_hint" | translate }}</span>
        </label>
        <div class="autocomplete-wrapper">
          <input
            type="text"
            class="is-autocomplete"
            [disabled]="!(canSubmit$ | async) || !!(submitting$ | async)"
            [formControl]="customerSearchControl"
            [matAutocomplete]="customerAuto"
            [placeholder]="'knowledge_base.ignore_codes.dialog.customer_placeholder' | translate"
          />
          <button
            *ngIf="customerSearchControl.value && (canSubmit$ | async) && !(submitting$ | async)"
            type="button"
            class="autocomplete-clear"
            (click)="clearCustomer(); $event.stopPropagation()"
          >
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <mat-autocomplete
          #customerAuto="matAutocomplete"
          [displayWith]="displayCustomerFn"
          (optionSelected)="onCustomerSelected($event.option.value)"
        >
          <mat-option *ngIf="customerSearchState === 'idle'" disabled>
            {{ "knowledge_base.ignore_codes.dialog.start_typing" | translate }}
          </mat-option>
          <mat-option *ngFor="let customer of filteredCustomers$ | async" [value]="customer">
            {{ customer.label }}
          </mat-option>
          <mat-option *ngIf="customerSearchState === 'results' && (filteredCustomers$ | async)?.length === 0" disabled>
            {{ "knowledge_base.ignore_codes.dialog.no_customers" | translate }}
          </mat-option>
        </mat-autocomplete>
      </div>
    </div>
  </form>
  <ui-button
    customConfirm
    *appHasPermission="submitPermission()"
    type="primary"
    [label]="(isUpdate ? 'common.update' : 'common.create') | translate"
    icon="arrow-right"
    iconPosition="end"
    [disabled]="!!(submitting$ | async)"
    (click)="save()"
  >
  </ui-button>
</app-shared-dialog>
